import React, { useState } from "react";
import { useSnackbar } from "notistack";
import axios from "axios";
import ReactGA from "react-ga4";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/subscriber`,
        {
          email,
        }
      );
      ReactGA.event({
        category: "subsbriber",
        action: "substicao",
      });
      enqueueSnackbar(`Subscription successful: ${response.data.email}`, {
        variant: "success",
      });
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error);
      enqueueSnackbar("Error subscribing: " + error.response.data, {
        variant: "error",
      });
    }
  };

  const handleScouterClick = () => {
    const isScouterAuthenticated = localStorage.getItem("scouterToken");
    if (isScouterAuthenticated) {
      navigate("/games");
    } else {
      navigate("/scout");
    }
  };

  return (
    <footer className="footer p-8 bg-base-200 text-base-content">
      <nav>
        <h6 className="footer-title">Instagram</h6>
        <div className="gap-2">
          <a
            href="https://www.instagram.com/adautoaraujo.com.br/"
            className="flex align-center"
          >
            <h2 className="text-lg">@adautoaraujo.com.br</h2>
          </a>
        </div>
      </nav>
      <nav>
        <h6 className="footer-title">{t("common.support")}</h6>
        <a
          href="mailto:contato@adautoaraujo.com.br"
          className="link link-hover"
        >
          contato@adautoaraujo.com.br
        </a>
        {/* <a className="link link-hover">+99 999 99</a> */}
      </nav>
      <NavLink to="/admin/" className="text-gray-500">
        Admin
      </NavLink>
      {/* <button onClick={handleScouterClick} className="text-gray-500">
        Scouter
      </button> */}
    </footer>
  );
};

export default Footer;
